import { ComponentType } from "react";
import CardListPage from "@pages/CardListPage";
import TextPage from "@pages/TextPage";
import LinksPage from "@pages/LinksPage";
import Page404 from "@pages/NotFoundPage";
import { BackendNode } from "@dtos/backend-node.dto";
import { AppRoute } from "@models/app-route.model";
import { TYPE_ROUTE_ENUM } from "@enums/type-route.enum";
import AccomodationPage from "@pages/AccomodationPage";
import SuggestionPage from "@pages/SuggestionPage";

export class RouteFactory {
  static createRoute(node: BackendNode): AppRoute {
    let Component: ComponentType<any>;

    switch (node.type) {
      case TYPE_ROUTE_ENUM.CARD_INFO:
        Component = CardListPage;
        break;
      case TYPE_ROUTE_ENUM.CARD_TEXT:
        Component = TextPage;
        break;
      case TYPE_ROUTE_ENUM.CARD_LINK:
        Component = LinksPage;
        break;
      case TYPE_ROUTE_ENUM.CARD_SUGGESTION:
        Component = SuggestionPage;
        break;
      case TYPE_ROUTE_ENUM.HOME:
        Component = AccomodationPage;
        break;
      default:
        Component = Page404;
    }

    return {
      id: node.id,
      path: node.qrCodeId || node.id.toString(),
      element: Component,
      children: node.children
        ? node.children.map((child: any) => RouteFactory.createRoute(child))
        : []
    };
  }
}
